<template>
    <transition name="slide-in-right">
        <div class="sidebar-container">
            <img :src="ViewCompany" alt="Privacy Frameworks Table" class="logo" />
        </div>
    </transition>
</template>
<script setup lang="ts">
import ViewCompany from '@/assets/images/admin/companies/view-company.png';
import { getDialogRef } from '~/composables/dynamic-dialog';
import { ModalNames } from '~/types/modals';

const dialogRef = getDialogRef(ModalNames.VIEW_COMPANY);

const closeDialog = () => {
    dialogRef.value.close();
};

</script>

<style lang="scss" scoped>
.sidebar-container {
    @apply bg-white h-screen flex flex-col overflow-y-auto right-0 fixed top-0;
    animation: slide-in-right 0.3s ease-in-out;
}

//using vue3 transition to slide in from right

@keyframes slide-in-right {
    from {
        transform: translateX(100%);
    }
    to {
        transform: translateX(0);
    }
}

@keyframes slide-out-right {
    from {
        transform: translateX(0);
    }

    to {
        transform: translateX(100%);
    }
}
</style>
